<template>
    <div class="centered-page">
        <div class="project-details">
            <div class="header-row">
                <img :src="assetPath(project().logo)" class="logo">
                <div class="title"> {{ project().title }}</div>
            </div>
            <div class="row">
                <div class="column">
                    <div class="desc">{{ project().desc }}</div>
                    <div class="store-links">
                        <a :href="project().appleLink">
                            <img src="../assets/AppleStoreLink.png" class="store-link">
                        </a>
                        <a :href="project().androidLink">
                            <img src="../assets/GooglePlayLink.png" class="store-link">
                        </a>
                    </div>
                    <div class="pill-buttons">
                        <router-link :to="{ name: 'PrivacyPolicy', params: { appName: project().link }}" class="pill-button">
                            <span>Privacy Policy</span>
                        </router-link>
                        <router-link :to="{ name: 'TermsConditions', params: { appName: project().link }}" class="pill-button">
                            <span>Terms & Conditions</span>
                        </router-link>
                    </div>
                </div>
                <img :src="assetPath(project().preview)" class="preview">
            </div>
            
        </div>
    </div>
</template>

<script>
import router from '@/router';
import json from "../data/projects.json";

export default {
    props: ['appName'],
    data() {
        return {
            projects: json.projects
        } 
    },
    mounted() {
    
    },
    methods:{
        project()
        {
            var project = this.projects.find(p => p.link == this.appName)

            if(project == null)
            {
                router.go(-1);
            }
            return project;
        },
        assetPath(asset)
        {
            return require('../assets/' + asset);
        }
    }
}
</script>

<style>
.project-details, .privacy-policy, .contact
{
    max-width: 1200px;
    margin:1rem;
    display: flex;
    flex-direction: column;
    background:white;
    padding: 1rem;
    border-radius: 20px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
}
.project-details .header-row, .privacy-policy .header-row
{
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    column-gap: 1rem;
}

.project-details .row
{
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;
}

.project-details .title, .privacy-policy .title
{
    font-weight: bold;
    font-size: 35px;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
}

.project-details .logo, .privacy-policy .logo
{
    max-width: 5rem;
    max-height: 5rem;
}
.project-details .preview
{
    max-width: 25rem;
}

.project-details .desc
{
    max-width: 20rem;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    line-height: 1.7;
    font-size: 18px;
}

.project-details .column
{
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 3rem;
    align-items: center;
}

.pill-buttons
{
    display: flex;
    column-gap: 1rem;
    column-gap: 1rem;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}


</style>
